<template>
    <div class="bg_eef1fa detail web_detail">
        <div class="main flex_space_between">
            <div class="left ">
                <div class="article_detail" v-html="detail.content">
                </div>
            </div>
            <div class="right">
                <div class="detail_intro">
                    <h2>{{detail.title}}</h2>
                    <p class="flex_start flex_wrap">
                        <span v-for="(item,index) in detail.flag">{{item}}</span>
                    </p>
                    <div class="detail_intro_download flex_start">
                        <div class="download" @click="downloadBtn(detail.id)">立即下载</div>
                        <img src="@/assets/images/like.png" @click="likeBtn(detail.id)" v-if="is_like == 0" />
                        <img src="@/assets/images/header_red.png" @click="likeBtn(detail.id)" v-else />
                    </div>
                    <hr/>
                    <div class="article">
                        <i>简介：</i>
                        <div class="article_main">
                            {{detail.intro}}
                        </div>
                    </div>
                    <div class="detail_list flex_space_between align_items_center">
                        <img src="@/assets/images/geshi.png">
                        <i>来源</i>
                        <label>{{detail.source}}</label>
                    </div>
                    <div class="detail_list flex_space_between align_items_center">
                        <img src="@/assets/images/shijian.png">
                        <i>上传时间</i>
                        <label>{{detail.create_time}}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "detail",
        data () {
            return {
                id: 0,
                detail:[],
                is_like: 0,
                is_good: 0
            }
        },

        created() {
            this.id = this.$route.query.id;
            this.$http({
                url: 'index/article',
                method: 'post',
                headers: {"Content-Type": "multipart/form-data"},
                data:{type:'teximg',id:this.id,token: localStorage.getItem('user_token')}
            }).then(res => {
                if(res.data.code == 1) {
                    this.detail = res.data.data.detail;
                    this.is_like = res.data.data.is_like;
                    this.is_good = res.data.data.is_good;
                } else {
                    layer.msg(res.data.msg);
                }
            });
        },
        mounted() {
        },
        methods: {
            likeBtn: function (id) {
                let _this = this;

                if(!localStorage.getItem('user_id'))
                {
                    layer.msg('请先登录，正在为您跳转，请稍后。。。');
                    setTimeout(function () {
                        _this.$router.push({
                            path: '/my/login'
                        })
                    },1500);
                    return false;
                }
                _this.$http({
                    url: 'my/likeBtn',
                    method: 'post',
                    headers: {"Content-Type": "multipart/form-data"},
                    data:{id:id,token: localStorage.getItem('user_token')}
                }).then(res => {
                    if(res.data.code == 1)
                    {
                        _this.is_like = _this.is_like == 1 ? 0 : 1;
                    }
                    layer.msg(res.data.msg);
                });
            },
            downloadBtn: function (id) {
                let _this = this;

                if(!localStorage.getItem('user_id'))
                {
                    layer.msg('请先登录，正在为您跳转，请稍后。。。');
                    setTimeout(function () {
                        _this.$router.push({
                            path: '/my/login'
                        })
                    },1500);
                    return false;
                }
                _this.$http({
                    url: 'my/downloadBtn',
                    method: 'post',
                    headers: {"Content-Type": "multipart/form-data"},
                    data:{id:id,token: localStorage.getItem('user_token')}
                }).then(res => {
                    if(res.data.code == 1)
                    {
                        let a = $("<a href='" + _this.detail.pic + "' target='_blank' download></a>").get(0);
                        let e = document.createEvent('MouseEvents');
                        e.initEvent('click', true, true);
                        a.dispatchEvent(e);
                    }else {
                        layer.msg(res.data.msg);
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .detail{padding:45px 0 35px;}
    .left{width: 913px;display: block;background: #fff;}
    .left_detail{padding:30px;display: block;}
    .left_detail img{max-width: 100%;width: 100%;object-fit: contain;display: block;margin:0 auto;}
    .right{width: 265px;display: block;}
    .right_img{width: 100%;object-fit: cover;display: block;}

    .detail_intro{width:100%;padding:20px;background: #fff;}
    .detail_intro h2{width:100%;font-size:20px;line-height: 40px;color:#000;display: block;}
    .detail_intro p{width: 100%;margin-top:10px;margin-bottom: 23px;}
    .detail_intro p span{width: auto;font-size:14px;line-height: 21px;padding:0 10px;color:#000;display: block;border:1px solid #000;border-radius: 16px;margin-right: 16px;margin-bottom: 3px;}
    .detail_intro_download{width: 100%;}
    .detail_intro_download .download{width: 165px;height: 37px;line-height: 37px;border-radius: 19px;text-align: center;background: #0a9cfd;color:#fff;font-size:18px;}
    .detail_intro_download img{width: auto;flex-grow: 1;height: 37px;padding:4px 0 5px;display: block;object-fit: contain;}
    .detail_intro hr{width: 100%;height: 1px;margin:32px 0 20px;background: #cdcdcd;display: block;border: none;}
    .detail_list{width: 100%;font-size:14px;line-height: 36px;}
    .detail_list img{height: 14px;object-fit: contain;display: block;margin-right: 3px;}
    .detail_list i{font-style: normal;flex-grow: 1;display: block;}

    .article{margin-bottom: 15px;}
    .article i{font-size:16px;line-height: 16px;color:#000;font-weight: bold;width: 100%;display: block;}
    .article_main{width: 100%;font-size:14px;line-height: 20px;color:#666;display: block;}

    .article_detail{width: 100%;display: block;font-size: 16px;line-height: 30px;color:#333;padding:20px 20px;/*background: #f5f5f5;*/}
    .article_detail img{max-width: 100%;object-fit: contain;margin:0 auto;display: block;}

    @media screen and (max-width: 1920px) {
        .detail{padding:3.629vw 0 2.8225vw;}
        .web_detail .right{display: none;}
        .web_detail .left{width:96%;margin:0 auto;}
        .web_detail .article_detail{width: 100%;padding:0;}
    }
</style>



// WEBPACK FOOTER //
// src/pages/teximg/detail.vue